import { render, staticRenderFns } from "./fieldset-section.vue?vue&type=template&id=51f74ca1&lang=pug&"
import script from "./fieldset-section.vue?vue&type=script&lang=js&"
export * from "./fieldset-section.vue?vue&type=script&lang=js&"
import style0 from "./fieldset-section.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports